import React, { useEffect, useRef } from 'react';
import './Advertisement.css';

const Advertisement = ({ user, adType = 'default', className = '' }) => {
  const adContainerRef = useRef(null);

  useEffect(() => {
    // Only load the ad if the user is not logged in or doesn't have the no_ads flag set
    if (!user || !user.no_ads) {
      let scripts = [];

      if (adType === 'mainScreen') {
        // Create first script element (options)
        const optionsScript = document.createElement('script');
        optionsScript.type = 'text/javascript';
        optionsScript.text = `
          atOptions = {
            'key' : 'dc148c1c5c11d3e698c1d6f970f1ae73',
            'format' : 'iframe',
            'height' : 250,
            'width' : 300,
            'params' : {}
          };
        `;
        scripts.push(optionsScript);

        // Create second script element (invoke)
        const invokeScript = document.createElement('script');
        invokeScript.type = 'text/javascript';
        invokeScript.src = '//breakingcapricorn.com/dc148c1c5c11d3e698c1d6f970f1ae73/invoke.js';
        scripts.push(invokeScript);
      }

      // Capture the current ref value
      const currentAdContainer = adContainerRef.current;

      // Append the scripts to the ad container
      if (currentAdContainer) {
        scripts.forEach(script => {
          currentAdContainer.appendChild(script);
        });
      }

      // Cleanup function to remove the scripts when component unmounts
      return () => {
        if (currentAdContainer) {
          scripts.forEach(script => {
            if (currentAdContainer.contains(script)) {
              currentAdContainer.removeChild(script);
            }
          });
        }
      };
    }
  }, [user, adType]); // Re-run effect if user or adType changes

  // Don't render anything if user has no_ads flag
  if (user && user.no_ads) {
    return null;
  }

  return (
    <div className={`advertisement-container ${className}`} ref={adContainerRef}>
      {/* The ad script will insert content here */}
    </div>
  );
};

export default Advertisement;
